import { OrganisationActionTypes } from './types';
import { action } from 'typesafe-actions';

export const fetchUserOrganisationStart = () =>
  action(OrganisationActionTypes.FETCH_USER_ORGANISATION_START);
export const fetchUserOrganisationSuccess = (data: any) =>
  action(OrganisationActionTypes.FETCH_USER_ORGANISATION_SUCCESS, data);
export const fetchUserOrganisationFailure = (error: any) =>
  action(OrganisationActionTypes.FETCH_USER_ORGANISATION_FAILURE, error);
